const ChatAvatar = ({ avatar, username }) => {
  return (
    <div className="flex items-center">
      <img src={avatar} alt="avatar" className="h-6 w-6 rounded-full" />
      <span className="p-1 font-medium text-primary text-sm">{username}</span>
    </div>
  )
}

export default ChatAvatar
